<template>
  <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M11.125 9.44687C11.5125 4.94687 13.825 3.10938 18.8875 3.10938H19.05C24.6375 3.10938 26.875 5.34688 26.875 10.9344V19.0844C26.875 24.6719 24.6375 26.9094 19.05 26.9094H18.8875C13.8625 26.9094 11.55 25.0969 11.1375 20.6719" stroke="#2C2738" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M2.5 15H18.6" stroke="#2C2738" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M15.8125 10.8125L20 15L15.8125 19.1875" stroke="#2C2738" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>

<script>
import iconMixin from "@/services/iconMixins.js";

export default {
  mixins: [iconMixin]
};
</script>
